export enum ModuleOptions {
  ALL = '1',
  SPECIFIC = '2',
}

export interface SuspendProtectionFormValue {
  taskName: string;
  modulesOption: ModuleOptions;
  duration: number;
  modules: Record<string, boolean>;
  runScanOnResume: boolean;
  understandTheRisk: boolean;
}

export interface SuspendProtectionTaskRequest {
  settings:SuspendProtectionTaskSettings;
}

export interface SuspendProtectionTaskSettings {
  path: string,
  taskName: string,
  type: number,
  targets: any,
  specifics: SuspendProtectionTaskSpecifics
}

export interface SuspendProtectionTaskSpecifics {
  modules: Record<string, boolean>;
  duration: number;
  understandTheRisk: boolean;
  runScanOnResume: boolean;
}
